<template>
  <div id="item_shop">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-row class="item_shop_lucky_height">
      <van-col span="22" offset="1" v-for="(l) in list" :key="l.id">
        <van-col span="24" class="item_shop_lucky_name">{{ l.figure }} {{ $t('column.good_number')}}</van-col>
        <van-col span="8" class="item_shop_lucky_type" v-for="(c) in l.list" :key="c.id">
          <van-col span="24" class="item_shop_lucky_div">
            <van-col span="24" class="item_shop_lucky_div_name">{{ c.luck_num }}</van-col>
            <van-col span="24" class="item_shop_lucky_div_sum">{{ c.price }} <img :src="consumer_price_Icon"/></van-col>
            <van-col span="18" offset="3" class="item_shop_lucky_btn">
              <van-button  @click="luck_btn(c.id, c.price)" round block size="small" color="#AE2CF1">{{ $t('btn.purchase')}}</van-button>
            </van-col>
          </van-col>
        </van-col>

      </van-col>
    </van-row>
  </div>
</template>
<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
export default {
  data() {
    return {
      list:[],
      consumer_price_Icon: '',
      document_title: '',
    }
  },
  created: function() {
    this.convert();
    this.document_title = this.$t('title.lucky')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    },
    convert: function() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=lucky_list", {
        params : {
          user_id: uid,
          token: token
        }
      }).then(res =>{
        console.log(res.data)
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = res.data.data.type
        this.consumer_price_Icon = res.data.data.consumer_price_Icon

      })
    },
    luck_btn (id, type) {
      const name =  this.$t('Tips.is_buy_a_good_number')
      Dialog.confirm({
        title: this.$t('Tips.buy_good_number'),
        message: name,
        confirmButtonColor: '#AE2CF1',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=pay_lucky", {
          params : {
            user_id: uid,
            token: token,
            id: id,
            type : type
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.convert()
          }
        })
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item_shop_lucky.vue